export enum SchemaStatus {
    ACTIVE = "ACTIVE",
    AWAITING = "AWAITING",
    EXPIRED = "EXPIRED",
    INACTIVE = "INACTIVE",
    SENT = "SENT",
    SENTTODD2 = "SENTTODD2"
}

export enum SchemaAction {
    "SAVE",
    "SEND",
    "DELETE"
}

export enum SchemaActionStatus {
    "ERROR",
    "SUCCESS"
}

export enum SchemaTabs {
    ACTIVE = "ACTIVE",
    HISTORICAL = "HISTORICAL",
    OTHERS = "OTHERS"
}

export enum SchemaInfoStatus {
    Deleted = "Deleted",
    Edited = "Edited",
    Editable = "Editable",
    Ineditable = "Ineditable",
    Expired = "Expired"
}

export enum DataEnteredBy {
    Doctor = "Doctor",
    Patient = "Patient",
    Assisted = "Assisted"
}

export enum SchemaAccessStatus {
    Success = "Success",
    Denied = "Denied",
    Assisted = "Assisted"
}